import { CheckCircle, CreditCard, Loader2, ScanLine, XCircle } from "lucide-react";
import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";

const StatusAlert = ({ loading, status, message, retry, type }) => {
  const [effectKey, setEffectKey] = useState(0);

  useEffect(() => {
    // restart animation on every change
    setEffectKey((prev) => prev + 1);
  }, [status, message]);

  if (!status) return null;

  // Map status to Bootstrap classes and icons
  const config = {
    success: {
      alertClass: "alert-success",
      icon: "bi-check-circle-fill",
      Icon: (
        <CheckCircle className="text-green-500"
          style={{ width: "3rem", height: "3rem" }}
        />
      ),
    },
    pending: {
      alertClass: "alert-light",
      icon: "bi bi-arrow-repeat",
      Icon: (
        <Loader2
          className="text-warning mb-3 spinner-border"
          style={{ width: "3rem", height: "3rem" }}
        />
      ),
      img: "./clock time.gif",
    },
    scaning: {
      alertClass: "alert-secondary",
      icon: "bi bi-upc-scan",
      Icon: (
        <ScanLine
          style={{ width: "3rem", height: "3rem" }}
        />
      ),
      img: "./Scanner.gif",
    },
    extract: {
      alertClass: "alert-info",
      icon: "bi bi-card-text",
      Icon: (
        <CreditCard
          style={{ width: "3rem", height: "3rem" }}
        />
      ),
      img: "./Searching.gif",
    },
    failed: {
      alertClass: "alert-danger",
      icon: "bi-x-circle-fill",
      Icon: (
        <XCircle
          className="text-red-500"
          style={{ width: "3rem", height: "3rem" }}
        />
      ),
    },
  }[status] || { alertClass: "alert-secondary", icon: "bi-info-circle-fill" };

  return (
    <>
      {type === 'out' && (
        <div
          key={`${status}-${message}`}
          className={`alert ${config?.alertClass} d-flex align-items-center border shadow-sm fade-in-up`}
          role="alert"
          style={{ minWidth: "300px" }}
        >

          <>
            <i className={`${config?.icon} fs-5 me-3`} />
          </>


          <div className="flex-grow-1 text-dark">
            <b>{message}</b>
          </div>

          {status == "failed" && (
            <button className="btn btn-primary" onClick={retry}>
              Try Again
            </button>
          )}

          {loading && (
            // Standard Bootstrap Spinner
            <div
              className="spinner-border spinner-border-sm ms-auto"
              role="status"
            >
              <span className="visually-hidden">Loading...</span>
            </div>
          )}
        </div>
      )}


      {type === 'in' && (
        <div className="d-flex flex-column align-items-center justify-content-center py-4">
          <Loader2
            className="text-warning mb-3 spinner-border"
            style={{ width: "3rem", height: "3rem" }}
          />
          <h5 className="fw-bold text-dark">
            {/* Analyzing Document... */}
            {message}
          </h5>
          <p className="text-muted mb-0">
            Extracting location, dates, and rates.
          </p>
        </div>
      )}
      {/* {config?.img && (
        <div
          className="position-absolute w-100 h-100 d-flex justify-content-center align-items-center"
          style={{ top: "10%", left: 0, zIndex: 999 }}
        >
          <img
            src={config?.img}
            style={{
              // only shrink for pending & extract
              width:
                status === "pending" || status === "extract" ? "60%" : "100%",
              height:
                status === "pending" || status === "extract" ? "60%" : "100%",
              objectFit: "contain",
            }}
          />
        </div>
      )} */}
    </>
  );
};

export default StatusAlert;
